import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "gallery-block" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "gallery" }
const _hoisted_5 = {
  key: 1,
  class: "text-info"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "more", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppGalleryEl = _resolveComponent("AppGalleryEl")!
  const _component_AppGalleryModal = _resolveComponent("AppGalleryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", {
          class: "title",
          innerHTML: _ctx.pageData['galleryTitle']
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iteratedList, (el, index) => {
            return (_openBlock(), _createBlock(_component_AppGalleryEl, {
              key: el['ID'],
              page: 'portfolio-page',
              elementData: el['acf'],
              onClick: ($event: any) => (_ctx.galleryModal(true, index, el['acf']['galleryListProductHash']))
            }, null, 8, ["elementData", "onClick"]))
          }), 128))
        ]),
        (_ctx.iteratedListLength > _ctx.shownLimit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-blue",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (this.shownLimit+=10))
            }, _toDisplayString(_ctx.pageData['galleryButtonText']), 1))
          : (_openBlock(), _createElementBlock("h3", _hoisted_5, [
              _createTextVNode("And much "),
              _hoisted_6,
              _createTextVNode("...")
            ]))
      ])
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.galleryModalActive)
          ? (_openBlock(), _createBlock(_component_AppGalleryModal, {
              key: 0,
              onGalleryModal: _ctx.galleryModal,
              modalData: _ctx.iteratedList[_ctx.currentIndex]['acf'],
              pageData: _ctx.pageData
            }, null, 8, ["onGalleryModal", "modalData", "pageData"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}